import React from 'react'
import { Doughnut } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

const EnvironmentalSocialCategory = ({ more3mmLegend, doughnutData, doughnutoptions }) => {
    const { t } = useTranslation();

    return (
        <>
            <p className="panel-title-safeguards">{t('extended_report.environmental_and_social_distribution')}</p>
            <div className="panel-body-safeguards">
                <div className='clasification-distribution'>
                    <div className='content-projects'>
                        <div>
                            {more3mmLegend.map(({ label, value, color }) => {
                                return (
                                    <div key={label}>
                                        <div className='content-distribution legend-circle'>
                                            <div className='dot-style' style={{ backgroundColor: color }}></div>
                                            <p>{label}</p>
                                        </div>
                                        <p className='numberOfProyects'>{`${value} ${t('one_pager_report.projects')}`}</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className='doughnut-monitoring'>
                        <Doughnut data={doughnutData} options={doughnutoptions} />
                    </div>

                </div>
            </div>
        </>
    )
}

export default EnvironmentalSocialCategory